/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SelectedUsersDto } from '../models/SelectedUsersDto';
import type { TeamPerfomanceDto } from '../models/TeamPerfomanceDto';
import type { TeamPerfomanceSubmitModel } from '../models/TeamPerfomanceSubmitModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TeamPerfomanceService {

  /**
   * @param dateFrom
   * @param users
   * @returns TeamPerfomanceDto Success
   * @throws ApiError
   */
  public static getUsersPerfomance(
    dateFrom?: string,
    users?: Array<number>,
  ): CancelablePromise<Array<TeamPerfomanceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/perfomance',
      query: {
        'dateFrom': dateFrom,
        'users': users,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postUsersPerfomance(
    requestBody?: TeamPerfomanceSubmitModel,
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/perfomance',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dateFrom
   * @param users
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersPerfomanceSaveCommission(
    dateFrom?: string,
    users?: Array<number>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/perfomance/save-commission',
      query: {
        'dateFrom': dateFrom,
        'users': users,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns SelectedUsersDto Success
   * @throws ApiError
   */
  public static getUsersPerfomanceSelection(): CancelablePromise<Array<SelectedUsersDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/perfomance/selection',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId
   * @returns boolean Created
   * @throws ApiError
   */
  public static postUsersPerfomanceSelection(
    userId: number,
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/perfomance/{userId}/selection',
      path: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteUsersPerfomanceSelection(
    userId: number,
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/perfomance/{userId}/selection',
      path: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
